import { SelectHTMLAttributes, forwardRef } from 'react';

import {
  getInputClassNames,
  FormGroup,
  SharedInputProps,
} from '@/components/FormElements';
import CaretDown from '@/icons/react/CaretDown';

export interface SelectOptionType {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps
  extends SharedInputProps,
    Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  options: SelectOptionType[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      displaySize = 'md',
      invalid,
      label,
      hideLabel,
      id,
      options,
      helpText,
      ...props
    },
    ref,
  ) => {
    const inputClasses = getInputClassNames({
      displaySize,
      invalid,
      additional: 'group flex items-center gap-2',
    });

    return (
      <FormGroup
        label={label}
        id={id}
        hideLabel={hideLabel}
        required={props.required}
        helpText={helpText}
      >
        <div className={inputClasses}>
          <select id={id} ref={ref} className="select-reset" {...props}>
            {options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
          </select>
          <CaretDown />
        </div>
      </FormGroup>
    );
  },
);

Select.displayName = 'Select';
